<div class="formulario">
    <form [formGroup]="form" #psForm="ngForm">
        <div class="container jumbotron">
            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <h1 mat-dialog-title class="titulo">Alterar Estado Máquina</h1>
                </div>
            </div>
            <div align="right">
                <div class="row justify-content-md-center">
                    <div class="col-lg-10">
                        Situação: <strong>{{situacao}}</strong>
                    </div>
                </div>
            </div>
            <br>
            <div class="row justify-content-md-center">
                <div class="col-lg-10">

                    <mat-form-field appearance="fill" class="full-width">
                        <input matInput placeholder="Nome da Máquina" formControlName="nomeMaquina" [readonly]=true>
                    </mat-form-field>
                </div>
            </div>
            <br>
            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    Novo Estado:
                    <mat-radio-group formControlName="situacao" class="person-radio-group">
                        <mat-radio-button *ngIf="situacao == 'Bloqueado'" value="1" [checked]="true" color="primary">
                            Ativo</mat-radio-button>
                        <mat-radio-button *ngIf="situacao == 'Ativo'" value="2" [checked]="true" color="primary">
                            Bloqueado</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <section class="tp-section">
                        <mat-checkbox (change)="showOptions($event)" class="example-margin" formControlName="chktermo"
                            color="primary">
                            <div class="example-button-row">
                                <button mat-button (click)="openDialog()">
                                    <span class="termo">Termo de Aceite.</span> </button>
                            </div>
                        </mat-checkbox>
                    </section>
                </div>
            </div>
            <div class="row justify-content-md-end">
                <div class="col-lg-10">
                    <div mat-dialog-actions class="botoes">
                        <br />
                        <button mat-raised-button class="md-icon-button btnOK" (click)="gravar()"
                            [disabled]="!psForm.valid || botaoContinuarClicado || terminoExecucao">
                            Continuar
                        </button>
                        &nbsp;
                        <button  mat-raised-button class="md-icon-button btnNok" (click)="onClose()">
                            <img class="img-fluid" src="assets/icons/white_close_icon.png" width="16px" /> Fechar
                        </button>
                    </div>
                </div>
            </div>

            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <mat-progress-bar *ngIf="terminoExecucao" mode="indeterminate"></mat-progress-bar>
                </div>
            </div>

            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <div *ngFor='let message of messageService.messages'>
                        <small *ngIf="!cadastrado()" class="p-3 mb-2 bg-danger text-white">
                            {{message}}
                        </small>
                        <small *ngIf="cadastrado()" class="p-3 mb-2 bg-success text-white">
                            {{message}}
                        </small>
                    </div>
                </div>
            </div>



        </div>
        <div id="myDiv" class="container" #termo hidden>
            <app-termo-aceite></app-termo-aceite>
        </div>
    </form>
</div>